<template>
  <v-app>
    <v-toolbar 
      :clipped-left="clipped" 
      app 
      class="hideOnPrint">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"/>
      <v-toolbar-items>
        <v-btn
          v-for="route in routes"
          v-show="!route.hidden"
          :key="route.name"
          :to="{ name: route.name }"
          flat
          active-class=""
          exact-active-class="v-btn--active"
          v-text="$t(route.displayNameKey)"
        />
      </v-toolbar-items>
      <v-spacer/>
      <!-- <v-btn @click="print()" v-if="['home'].indexOf($route.name) > -1">
        <v-icon>get_app</v-icon> {{ $t('download_cv') }}
      </v-btn> -->
      <v-btn
        :href="'/downloads/pdfs/' + this.$i18n.locale + '/CV.pdf'"
        class="hidden-sm-and-down"
        download
      >
        <v-icon>get_app</v-icon> {{ $t("download_cv") }}
      </v-btn>
      <locale-changer class="hidden-sm-and-down"/>
    </v-toolbar>
    <v-main>
      <div 
        id="printMe" 
        ref="content">
        <v-navigation-drawer
          :clipped="clipped"
          v-model="drawer"
          persistent
          enable-resize-watcher
          fixed
          app
          class="hideOnPrintExceptFirstPage"
        >
          <v-flex
            xs12
            align-center
            justify-center
            layout
            text-xs-center
            pt-3
            pb-1
          >
            <v-avatar 
              :tile="false" 
              :size="128" 
              color="grey lighten-4">
              <img 
                src="/images/me_new.jpg" 
                alt="avatar" >
            </v-avatar>
          </v-flex>
          <v-flex 
            xs12 
            align-center 
            justify-center 
            layout 
            text-xs-center>
            <span class="headline">Martin Aaby Finnerup</span>
          </v-flex>
          <v-divider v-if="printer_off"/>
          <v-container 
            row 
            wrap 
            grid-list-md 
            d-flex>
            <v-layout :wrap="printer_off">
              <v-flex>
                <v-list class="col">
                  <v-list-tile
                    v-for="(item, i) in items"
                    v-show="(item.printOnly && !printer_off) || !item.printOnly"
                    :key="i"
                    :to="
                      item && item.link && item.link.length > 0
                        ? null
                        : { name: item.route }
                    "
                    :href="item.link"
                    :target="item.openInNewTab ? '_blank' : ''"
                    value="true"
                  >
                    <v-list-tile-action>
                      <v-icon
                        v-if="item.icon !== undefined"
                        v-html="item.icon"
                      />
                      <ion-icon
                        v-else
                        :name="item.ionicon"
                        style="font-size: 24px"
                      />
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="item.title"/>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <!-- <v-divider v-if="printer_off"></v-divider>
          <v-divider v-if="!printer_off" vertical></v-divider> -->
              <v-flex>
                <v-list class="col mb-5">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ $t("skills") }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <div
                    v-for="(item, i) in skills"
                    v-show="!printer_off"
                    :key="i">
                    <div class="mt-2 mb-1"><v-icon>{{ item.action }}</v-icon> {{ $t(item.title) }}</div>
                    <v-chip
                      v-for="subItem in item.items"
                      :key="subItem.title">{{ subItem.title }}
                    </v-chip>
                  </div>
                  <v-expansion-panel 
                    v-if="printer_off"
                    v-model="skillsPanel" 
                    expand>
                    <v-expansion-panel-content
                      v-for="(item, i) in skills"
                      :key="i"
                    >
                      <div slot="header">
                        <v-icon>{{ item.action }}</v-icon> {{ $t(item.title) }}
                      </div>
                      <v-card>
                        <!-- <v-card-text class="grey lighten-3"></v-card-text> -->
                        <v-list dense>
                          <v-list-tile
                            v-for="subItem in item.items"
                            :key="subItem.title"
                          >
                            <v-list-tile-content>
                              <v-list-tile-title>{{
                                subItem.title
                              }}</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                              <v-icon>{{ subItem.action }}</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>
                        </v-list>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </v-navigation-drawer>
        <v-content>
          <router-view :printer_off="printer_off" />
        </v-content>
        <v-footer 
          :fixed="fixed" 
          app>
          <v-spacer/>
          <v-flex 
            py-3 
            text-xs-center 
            xs12>
            &copy; {{ new Date().getFullYear() }} —
            <strong>Martin Aaby Finnerup</strong>
          </v-flex>
        </v-footer>
      </div>
    </v-main>
    <v-bottom-nav
      :active.sync="bottomNav"
      :value="true"
      style="z-index: 50;"
      color="white"
      fixed
      class="hidden-md-and-up"
    >
      <locale-changer style="max-width: 168px; min-width: 80px;"/>
      <v-btn
        :href="'/downloads/pdfs/' + this.$i18n.locale + '/CV.pdf'"
        download
      >
        <span>{{ $t("download_cv") }}</span>
        <v-icon>get_app</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-app>
</template>

<style>
@media print {
  * {
    -webkit-print-color-adjust: exact;
  }

  .hideOnPrint * {
    display: none;
  }
  .hideOnPrintExceptFirstPage {
    height: 100vh !important;
    width: 100% !important;
    position: static;
    break-after: always;
    margin-top: 0 !important;
    /* position: absolute; */
    /* max-height: 1em; */
  }
  main.v-content {
    padding-top: 0 !important;
    padding-left: 0 !important;
  }
  .hideOnPrintExceptFirstPage .v-list__tile__action {
    margin-right: 5px;
    justify-content: flex-end;
    flex-grow: 1;
  }
  .hideOnPrintExceptFirstPage .v-list__tile__content {
    flex-grow: 0;
  }
  .hideOnPrintExceptFirstPage .v-list__tile__title {
    text-align: right !important;
  }
  .v-expansion-panel__header {
    padding: 3px 6px;
    min-height: 38px;
  }

  .v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
    height: 25px;
  }

  .v-bottom-nav {
    display: none !important;
  }

  /* For centered contact info */

  /* .hideOnPrintExceptFirstPage .v-list__tile__action {
    margin-right: 5px;
    justify-content: flex-end;
    flex-grow: 1;
  }
  .hideOnPrintExceptFirstPage .v-list__tile__content {
    flex-grow: 1.05;
  }
  .hideOnPrintExceptFirstPage .v-list__tile__title {
    text-align: left !important;
  } */
  /* End of "for centered contact info" */

  /* .flex, ul, img, , aside {
   page-break-inside: avoid;
} */
}
</style>

<script>
import localeChanger from "./components/LocaleChanger.vue";
// import printd from "printd";
// const pdfMake = require('pdfmake/build/pdfmake.js');
// const pdfFonts = require('pdfmake/build/vfs_fonts.js');
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

// import printer from "vue-printer";

export default {
  name: "App",
  components: {
    "locale-changer": localeChanger,
  },
  data() {
    return {
      printer_off: true,
      clipped: true,
      drawer: true,
      fixed: false,
      skillsPanel: [],
      items: [
        {
          icon: "phone",
          title: "+45 30 95 63 75",
          link: "tel:+45 30 95 63 75",
        },
        {
          icon: "email",
          title: "contact@codeslasher.com",
          link: "mailto:contact@codeslasher.com",
        },
        {
          icon: "web",
          title: "www.codeslasher.com",
          link: "https://www.codeslasher.com",
          printOnly: true,
          openInNewTab: true,
        },
        {
          ionicon: "logo-linkedin",
          title: "MaverickMartyn",
          link: "https://www.linkedin.com/in/MaverickMartyn",
          openInNewTab: true,
        },
        {
          ionicon: "logo-github",
          title: "MaverickMartyn",
          link: "https://www.github.com/MaverickMartyn",
          openInNewTab: true,
        },
        {
          icon: "fa-brands fa-bluesky",
          title: "MaverickMartyn",
          link: "https://bsky.app/profile/maverickmartyn.bsky.social",
          openInNewTab: true,
        },
      ],
      skills: [
        {
          action: "code",
          title: "programming_languages",
          active: false,
          items: [
            { title: "C#" },
            { title: "Firebird SQL" },
            { title: "Python" },
            { title: "Javascript" },
            { title: "Typescript" },
            { title: "HTML5" },
            { title: "CSS3" },
            { title: "PHP" },
          ],
        },
        {
          action: "widgets",
          title: "frameworks",
          active: false,
          items: [
            { title: ".NET" },
            { title: ".NET Core" },
            { title: "Umbraco CMS" },
            { title: "Blazor" },
            { title: "VueJS" },
            { title: "Vuetify" },
            { title: "Bootstrap" },
            { title: "ServiceStack" },
          ],
        },
        {
          action: "build",
          title: "tools",
          active: false,
          items: [
            { title: "Visual Studio 2026" },
            { title: "Visual Studio Code" },
            { title: "Azure DevOps" },
            { title: "Git" },
            { title: "GitLab" },
            { title: "Octopus Deploy" },
            { title: "Team City" },
            { title: "SSH" },
          ],
        },
        {
          action: "fa-diagram-project",
          title: "workflow_and_practices",
          active: false,
          items: [
            { title: "Code Reviews" },
            { title: "Test-Driven Development" },
            { title: "Continuous Integration" },
            { title: "Scrum" },
          ],
        },
      ],
    };
  },
  computed: {
    routes() {
      return this.$router.options.routes;
    }
  },
  watch: {
    $route() {
      this.activatePrintModeIfIsPrintable();
    },
  },
  mounted() {
    this.activatePrintModeIfIsPrintable();
  },
  methods: {
    activatePrintModeIfIsPrintable() {
      if (["printable"].indexOf(this.$route.name) > -1) {
        this.print(false);
      }
    },
    showAllSkills() {
      this.skillsPanel = this.skills.map(() => true);
    },
    // Reset the panel
    showNoSkills() {
      this.skillsPanel = [];
    },
    print(printWhenReady = true) {
      this.printer_off = false;
      this.showAllSkills();
      if (printWhenReady) {
        setTimeout(window.print, 500);

        setTimeout(() => {
          this.printer_off = true;
          this.showNoSkills();
        }, 500);
      }
    },
  },
};
</script>
